import React from 'react';
import { FaClock } from 'react-icons/fa';

export default function PagamentoPendente({ onVoltar }) {

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      padding: 20
    }}>
      <main role="status" aria-live="polite" style={{
        background: '#fff',
        borderRadius: 20,
        padding: 40,
        maxWidth: 500,
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <FaClock aria-hidden="true" style={{ fontSize: 64, color: '#b45309' }} />
        
        <h1 style={{ marginTop: 20, color: '#333' }}>
          Assinatura em processamento
        </h1>
        
        <p style={{ color: '#666', fontSize: 16, marginTop: 16, lineHeight: 1.6 }}>
          A autorização do cartão ou a primeira cobrança ainda está sendo processada.
        </p>

        <div style={{
          background: '#e3f2fd',
          border: '1px solid #2196f3',
          borderRadius: 8,
          padding: 16,
          marginTop: 24,
          textAlign: 'left'
        }}>
          <p style={{ margin: 0, fontSize: 14, color: '#1565c0' }}>
            <strong>O que acontece agora?</strong>
          </p>
          <ul style={{ margin: '8px 0 0 0', paddingLeft: 20, fontSize: 14, color: '#1565c0' }}>
            <li>O Mercado Pago concluirá a autorização do cartão.</li>
            <li>O ClimoraX confirmará a primeira cobrança sem precisar recarregar a página.</li>
            <li>O plano só será liberado depois da cobrança aprovada e conciliada.</li>
          </ul>
        </div>

        <div style={{
          background: '#fff8e1',
          border: '1px solid #ffc107',
          borderRadius: 8,
          padding: 16,
          marginTop: 16,
          textAlign: 'left'
        }}>
          <p style={{ margin: 0, fontSize: 14, color: '#856404', lineHeight: 1.5 }}>
            Seu plano será ativado automaticamente quando a primeira cobrança recorrente for aprovada.
          </p>
        </div>

        <button
          onClick={() => onVoltar && onVoltar()}
          style={{
            width: '100%',
            background: '#667eea',
            color: '#fff',
            border: 'none',
            borderRadius: 10,
            padding: '12px 20px',
            fontSize: 16,
            fontWeight: 600,
            cursor: 'pointer',
            marginTop: 30
          }}
        >
          Voltar ao Perfil
        </button>

        <p style={{ fontSize: 12, color: '#999', marginTop: 20 }}>
          Você pode verificar a assinatura e as próximas cobranças em Plano e recursos.
        </p>
      </main>
    </div>
  );
}
